/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useAuth} from '../core/Auth'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'
import Select from 'react-select'
import { initializeApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, collection, addDoc, setDoc, doc } from 'firebase/firestore/lite';
import {AuthModel} from '../models/AuthModel';
import {UserModel} from '../models/UserModel';
import ReactTooltip from 'react-tooltip';

const initialValues = {
  firstname: '',
  lastname: '',
  dateofbirth: Date(),
  age: '',
  phonenumber: '',
  grade: '',
  school: '',
  location: '',
  identityproof: '',
  email: '',
  password: '',
  changepassword: '',
  acceptTerms: false,
}

const registrationSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('First name is required'),
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  lastname: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Last name is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
  changepassword: Yup.string()
    .required('Password confirmation is required')
    .when('password', {
      is: (val: string) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('password')], "Password and Confirm Password didn't match"),
    }),
  dateofbirth: Yup.date()
    .max(new Date())
    .required('Date of birth is required'),
  phonenumber: Yup.number()
    .required('Phone number is required'),
  grade: Yup.object(),
  school: Yup.string()
    .required('School is required'),
  location: Yup.string()
    .required('Location is required'),
  identityproof: Yup.string()
    .required('Identity proof is required'),
  acceptTerms: Yup.bool().required('You must accept the terms and conditions'),
})

const firebaseConfig = {
  apiKey: "AIzaSyDnyomA90Kg1yrELokYx02jOHRs_Cm7LGc",
  authDomain: "gj08-6e7ea.firebaseapp.com",
  projectId: "gj08-6e7ea",
  storageBucket: "gj08-6e7ea.appspot.com",
  messagingSenderId: "527457566258",
  appId: "1:527457566258:web:da78475eabd5ae580b062b",
  measurementId: "G-KGVQ6TS2WV"
};

export function FacilitatorRegistration() {
  var [latitude, setLatitude] = useState(0.0);
  var [longitude, setLongitude] = useState(0.0);
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        // firebase user creation
        createUserOnFirebase(values)
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The registration details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  // Firebase variables
  const firebaseApp = initializeApp(firebaseConfig);
  const firebaseDB = getFirestore(firebaseApp);
  const firebaseAuth = getAuth(firebaseApp);

  const gradeOptions = [
    { value: 'Montessori', label: 'Montessori' },
    { value: 'Primary', label: 'Primary' },
    { value: 'High School', label: 'High School' },
    { value: 'College', label: 'College' },
    { value: 'University', label: 'University' }
  ]

  // State methods - start

  useEffect(() => {
    PasswordMeterComponent.bootstrap()

    if ("geolocation" in navigator) {
      console.log("location is available");
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log("Latitude is :", position.coords.latitude);
        console.log("Longitude is :", position.coords.longitude);

        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
      });
    } else {
      console.log("location is not available");
    }
  }, [])

  useEffect(() => {
    if(latitude !== 0.0) {
      formik.setFieldValue("location", latitude + ", " + longitude);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latitude, longitude])

  // State methods - end

  const handleGradeChange = (selectedGrade: any) => {
    formik.setFieldValue("grade", selectedGrade);
    console.log("formik ", formik);
  }

  // Firebase methods - start

  const createUserOnFirebase = (values: any) => {
    createUserWithEmailAndPassword(firebaseAuth, values.email, values.password)
      .then((userCredential) => {
        // Signed in 
        const user = userCredential.user;
        console.log("user: ", user);
        userCredential.user.getIdToken().then(function(token){
          console.log("accessToken: ", token);
          const authModel: AuthModel = {
            api_token: token,
            refreshToken: userCredential.user.refreshToken,
          };
          saveAuth(authModel)
        });
        createUserRecordInFirestoreDB(values);
      })
      .catch((error) => {
        switch (error.code) {
          case 'auth/email-already-in-use':
            console.log(`Email address ${values.email} already in use.`);
            formik.setStatus(`Email address ${values.email} already in use.`)
            setLoading(false);
            break;
          case 'auth/invalid-email':
            console.log(`Email address ${values.email} is invalid.`);
            formik.setStatus(`Email address ${values.email} is invalid.`)
            setLoading(false);
            break;
          case 'auth/operation-not-allowed':
            console.log(`Error during sign up.`);
            formik.setStatus(`Error during sign up.`)
            setLoading(false);
            break;
          case 'auth/weak-password':
            console.log('Password is not strong enough. Add additional characters including special characters and numbers.');
            formik.setStatus('Password is not strong enough. Add additional characters including special characters and numbers.')
            setLoading(false);
            break;
          default:
            console.log(error.message);
            formik.setStatus(error.message)
            setLoading(false);
            break;
        }
      });
  }

  async function createUserRecordInFirestoreDB(values: any) {
    try {
      // Set facilitators user into facilitators colection
      const userRef = await addDoc(collection(firebaseDB, "facilitators"), {
        firstname: values.firstname,
        lastname: values.lastname,
        dateofbirth: values.dateofbirth,
        phonenumber: values.phonenumber,
        grade: values.grade.value,
        // school: values.school,
        location: values.location,
        identityproof: values.identityproof,
        email: values.email,
        isfacilitator: 'true'
      });

      // Set school data of facilitator into schoolList colection with primary key as facilitator ref id
      await setDoc(doc(firebaseDB,  "schoolList", userRef.id), {
        school: values.school,
      });

      console.log("Facilitator added in firestore with ID: ", userRef.id);

      const userModel: UserModel = {
        id: values.id,
        username: values.email,
        email: values.email,
        password: values.password,
        first_name: values.firstname,
        last_name: values.lastname,
        fullname: values.firstname + " " + values.lastname,
        occupation: "facilitator",
        phone: values.phonenumber,
        address: values.location,
        phoneNumber: values.phonenumber,
        grade: values.grade,
        location: values.location
      };

      setCurrentUser(userModel);
      console.log("userModel: ", userModel);

      setLoading(false);

      // navigate to dashboard
    } catch (e) {
      console.error("Error adding facilitator in firestore: ", e);
      formik.setStatus("Error adding facilitator in firestore: " + e)
      setLoading(false);
    }
  }

  // Firebase methods - end

  const selectInputStyle = {
    option: (provided: any, state: any) => ({
      ...provided,
    }),
    control: (provided: any) => ({
      ...provided,
      border: 0,
      backgroundColor: 'transparent',
    })
  }

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signup_form'
      onSubmit={formik.handleSubmit}
    >
      <ReactTooltip delayShow={200} place="top" />
      <div className='text-center mb-5'>
        <a href='#' className='mb-4'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo.png')} className='h-45px' />
        </a>
      </div>
      {/* begin::Heading */}
      <div className='mb-10 text-center'>
        {/* begin::Title */}
        <h1 className='text-dark mb-3 auth-label'>Are you a facilitator?</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className='text-black-400 fw-bold fs-4'>
          Already have an account?
          <Link to='/auth/login' className='link-primary fw-bolder' style={{marginLeft: '5px'}}>
            Login
          </Link>
        </div>
        {/* end::Link */}
      </div>
      {/* end::Heading */}

      {/* begin::Action */}
      <button type='button' className='btn btn-light-primary fw-bolder w-100 mb-10'>
        <img
          alt='Logo'
          src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
          className='h-20px me-3'
        />
        Sign in with Google
      </button>
      {/* end::Action */}

      <div className='d-flex align-items-center mb-10'>
        <div className='border-bottom border-gray-300 mw-50 w-100'></div>
        <span className='fw-bold text-black-400 fs-7 mx-2'>OR</span>
        <div className='border-bottom border-gray-300 mw-50 w-100'></div>
      </div>

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* begin::Form group Firstname */}
      <div className='row fv-row mb-7'>
        <div className='col-xl-6'>
          <label className='form-label fw-bolder text-dark fs-6'>First name</label>
          <input
            data-tip="Put your first name here like 'Shuja'"
            placeholder='First name'
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('firstname')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.firstname && formik.errors.firstname,
              },
              {
                'is-valid': formik.touched.firstname && !formik.errors.firstname,
              }
            )}
          />
          {formik.touched.firstname && formik.errors.firstname && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.firstname}</span>
              </div>
            </div>
          )}
        </div>
        <div className='col-xl-6'>
          {/* begin::Form group Lastname */}
          <div className='fv-row mb-5'>
            <label className='form-label fw-bolder text-dark fs-6'>Last name</label>
            <input
              data-tip="Put your last name here like 'Hasan'"
              placeholder='Last name'
              type='text'
              autoComplete='off'
              {...formik.getFieldProps('lastname')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.lastname && formik.errors.lastname,
                },
                {
                  'is-valid': formik.touched.lastname && !formik.errors.lastname,
                }
              )}
            />
            {formik.touched.lastname && formik.errors.lastname && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.lastname}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group Date of birth */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Date of birth</label>
        <input
          data-tip="Select your date of birth from calendar"
          placeholder='Date of birth'
          type='date'
          autoComplete='off'
          {...formik.getFieldProps('dateofbirth')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.dateofbirth && formik.errors.dateofbirth},
            {
              'is-valid': formik.touched.dateofbirth && !formik.errors.dateofbirth,
            }
          )}
        />
        {formik.touched.dateofbirth && formik.errors.dateofbirth && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.dateofbirth}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Phone number */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Phone number</label>
        <input
          data-tip="Put your age here like '+0222588888'"
          placeholder='Phone number'
          type='number'
          autoComplete='off'
          {...formik.getFieldProps('phonenumber')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.phonenumber && formik.errors.phonenumber},
            {
              'is-valid': formik.touched.phonenumber && !formik.errors.phonenumber,
            }
          )}
        />
        {formik.touched.phonenumber && formik.errors.phonenumber && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.phonenumber}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Email */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Email</label>
        <input
          data-tip="Put your email here like 'shuja@test.com'"
          placeholder='Email'
          type='email'
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Grade */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Grade</label>
        
        <Select
          styles={selectInputStyle}
          placeholder="Currently Teaching"
          options={gradeOptions}
          {...formik.getFieldProps('grade')}
          onChange={selectedOption => {
            handleGradeChange(selectedOption);
          }}
          isSearchable={true}
          className={clsx(
            'form-control form-control-lg form-control-solid select-form-class',
            {'is-invalid': formik.touched.grade && formik.errors.grade},
            {
              'is-valid': formik.touched.grade && !formik.errors.grade,
            }
          )}
        />
        
        {formik.touched.grade && formik.errors.grade && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.grade}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group School */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>School</label>
        <input
          data-tip="Put your school here like 'ACG SchoolJakarta'"
          placeholder='School'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('school')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.school && formik.errors.school},
            {
              'is-valid': formik.touched.school && !formik.errors.school,
            }
          )}
        />
        {formik.touched.school && formik.errors.school && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.school}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Location */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Location</label>
        <input
          data-tip="Your current location latitude and longitude - It will be automatically populated"
          placeholder='Location - getting current location . . .'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('location')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.location && formik.errors.location},
            {
              'is-valid': formik.touched.location && !formik.errors.location,
            }
          )}
        />
        {formik.touched.location && formik.errors.location && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.location}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Identity Proof */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Identity Proof</label>
        <input
          data-tip="Add some kind of identity proof document"
          placeholder='Identity Proof'
          type='file'
          {...formik.getFieldProps('identityproof')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.identityproof && formik.errors.identityproof},
            {
              'is-valid': formik.touched.identityproof && !formik.errors.identityproof,
            }
          )}
        />
        {formik.touched.identityproof && formik.errors.identityproof && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.identityproof}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Password */}
      <div className='mb-10 fv-row' data-kt-password-meter='true'>
        <div className='mb-1'>
          <label className='form-label fw-bolder text-dark fs-6'>Password</label>
          <div className='position-relative mb-3'>
            <input
              data-tip="Put your password here like '12345678'"
              type='password'
              placeholder='Password'
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
            />
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
          {/* begin::Meter */}
          <div
            className='d-flex align-items-center mb-3'
            data-kt-password-meter-control='highlight'
          >
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
          </div>
          {/* end::Meter */}
        </div>
        <div className='text-muted'>
          Use 8 or more characters with a mix of letters, numbers & symbols.
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group Confirm password */}
      <div className='fv-row mb-5'>
        <label className='form-label fw-bolder text-dark fs-6'>Confirm Password</label>
        <input
          data-tip="Put your confirm password here like '12345678'"
          type='password'
          placeholder='Password confirmation'
          autoComplete='off'
          {...formik.getFieldProps('changepassword')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
            },
            {
              'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
            }
          )}
        />
        {formik.touched.changepassword && formik.errors.changepassword && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.changepassword}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='form-check form-check-custom form-check-solid'>
          <input
            className='form-check-input'
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('acceptTerms')}
          />
          <label
            className='form-check-label fw-bold text-black-700 fs-6'
            htmlFor='kt_login_toc_agree'
          >
            I Agree the{' '}
            <Link to='/auth/terms' className='ms-1 link-primary'>
              terms and conditions
            </Link>
            .
          </label>
          {formik.touched.acceptTerms && formik.errors.acceptTerms && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.acceptTerms}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg w-100 mb-5 continue-button'
          disabled={formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms}
        >
          {!loading && <span className='indicator-label'>Signup as facilitator</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_signup_form_cancel_button'
            className='btn btn-lg btn-light-primary w-100 mb-5'
          >
            Cancel
          </button>
        </Link>
      </div>
      {/* end::Form group */}
    </form>
  )
}
